import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
export var NsGraphZoom;
(function (NsGraphZoom) {
    /** Command: 用于注册named factory */
    NsGraphZoom.command = XFlowGraphCommands.GRAPH_ZOOM;
    /** zoom options */
    NsGraphZoom.MAX_SCALE = 1.5;
    NsGraphZoom.MIN_SCALE = 0.05;
    /** default zoom options */
    NsGraphZoom.defaultZoomOptions = {
        maxScale: NsGraphZoom.MAX_SCALE,
        minScale: NsGraphZoom.MIN_SCALE,
    };
    /** hookName */
    NsGraphZoom.hookKey = 'graphZoom';
})(NsGraphZoom || (NsGraphZoom = {}));
let GraphZoomCommand = 
/** 画布缩放命令 */
class GraphZoomCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.graphZoom.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { factor, zoomFitPadding = 12, zoomOptions = NsGraphZoom.defaultZoomOptions, } = handlerArgs;
                if (typeof factor === 'number') {
                    x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.zoom(factor, zoomOptions || {});
                }
                else if (factor === 'fit') {
                    x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.zoomToFit(Object.assign(Object.assign({}, zoomOptions), { padding: zoomFitPadding }));
                }
                else if (factor === 'real') {
                    x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.scale(1);
                    x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.centerContent();
                }
                return { factor, zoomFitPadding, zoomOptions };
            }), 
            /** execute command 时创建的hook */
            runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphZoomCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphZoomCommand.prototype, "init", null);
GraphZoomCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphZoom.command.id },
    })
    /** 画布缩放命令 */
], GraphZoomCommand);
export { GraphZoomCommand };
//# sourceMappingURL=graph-zoom.js.map